export default __webpack_public_path__ + "/assets/fonts/RethinkSans-Bold.ttf";